import Header from './Header'
import Footer from './Footer'
import BannerStudio from './BannerStudio'

export default function BannerStudioPage() {
    return (
        <div className="min-h-screen flex flex-col bg-ugandan-black overflow-x-hidden pt-20">
            <Header />
            <main className="flex-grow">
                <BannerStudio />
            </main>
            <Footer />
        </div>
    )
}
